import { useGetCommentsQuery } from 'features/comments/commentApi';

const emptyArray = [];

/**
 * @param {string} uri
 *
 * @returns {{
 *     comments: import('models/comments.models').Comment[],
 *     isLoading: boolean,
 * }}
 */
export function useGetEntityComments(uri) {
    return useGetCommentsQuery(uri, {
        selectFromResult: ({ data, isLoading }) => ({
            comments: data ?? emptyArray,
            isLoading,
        }),
    });
}
